// extracted by mini-css-extract-plugin
export default {"sidebarcomponentGridContainer":"sidebarComponent_sidebarcomponentGridContainer__kld4q"};